module.exports = __webpack_public_path__ + "img/img49.6395d47d.svg";